import React, { useMemo } from 'react';
import { Button, ProgressBar } from 'day8-ui';
import { IoIosStar } from '@react-icons/all-files/io/IoIosStar';
import { useInfoDrawer } from '../../../context/InfoDrawerContext';
import HeaderItem from '../../HeaderItem';
import ReviewsInfo from '../../InfoDrawer/ReviewsInfo/ReviewsInfo';
import { useActiveCompany } from '../../../context/ActiveCompanyContext';
var Large = function (_a) {
    var feedbackStats = _a.feedbackStats, className = _a.className, countryCode = _a.countryCode;
    var isYachtsAndFriends = useActiveCompany().isYachtsAndFriends;
    var average_nps = feedbackStats.average_nps, total_count = feedbackStats.total_count, nps_distribution = feedbackStats.nps_distribution, category_ratings = feedbackStats.category_ratings;
    var filteredCategoryRatings = useMemo(function () {
        if (isYachtsAndFriends) {
            return {
                skipper: category_ratings.skipper,
                hostess: category_ratings.hostess,
                yacht: category_ratings.yacht
            };
        }
        return category_ratings;
    }, [category_ratings, isYachtsAndFriends]);
    var openInfoDrawer = useInfoDrawer().openInfoDrawer;
    var sanitizedCategoryRatings = useMemo(function () {
        return Object.entries(filteredCategoryRatings).map(function (_a) {
            var category = _a[0], rating = _a[1];
            var icon = 'star';
            if (category === 'yacht') {
                icon = 'sea-transport-yacht';
            }
            else if (category === 'skipper') {
                icon = 'skipper';
            }
            else if (category === 'hostess') {
                icon = 'host';
            }
            else if (category === 'parties') {
                icon = 'music-dance';
            }
            else if (category === 'crew') {
                icon = 'people-man-cap';
            }
            else if (category === 'music') {
                icon = 'stereo';
            }
            return {
                category: category.charAt(0).toUpperCase() + category.slice(1),
                rating: rating,
                icon: icon
            };
        });
    }, [filteredCategoryRatings]);
    return (React.createElement("div", { id: "large-reviews-widget", className: "".concat(className) },
        React.createElement("div", { className: "dui-text-2xl dui-flex dui-items-center dui-gap-2" },
            React.createElement("h2", { className: 'dui-font-body dui-flex dui-items-start dui-gap-1 dui-shrink-0' },
                React.createElement(IoIosStar, null),
                average_nps),
            React.createElement("p", { className: 'dui-text-sm dui-text-gray-400' },
                "from ",
                React.createElement("strong", null, total_count),
                " reviews")),
        React.createElement("div", { className: "dui-mt-4 dui-grid dui-grid-cols-1 ".concat(!isYachtsAndFriends ? 'sm:dui-grid-cols-2' : '', " dui-gap-8") },
            React.createElement("div", null, ["5", "4", "3", "2", "1"].map(function (rating) { return (React.createElement("div", { key: rating, className: "dui-mt-4 dui-w-full" },
                React.createElement("div", { className: "dui-flex dui-justify-between dui-items-center dui-mb-2" },
                    React.createElement("label", { className: 'dui-flex dui-items-center dui-gap-2' },
                        React.createElement(IoIosStar, { className: "dui-text-secondary-500" }),
                        React.createElement("span", null,
                            " ",
                            rating,
                            " stars")),
                    React.createElement("div", { className: "dui-text-sm dui-text-gray-600" },
                        Math.round(+nps_distribution[rating].count * 100 / total_count),
                        "%")),
                React.createElement(ProgressBar, { className: 'dui-w-full', value: +nps_distribution[rating].count * 100 / total_count, max: 100 }))); })),
            React.createElement("div", { className: "dui-grid dui-grid-cols-3 ".concat(!isYachtsAndFriends ? 'sm:dui-grid-cols-2' : '', " dui-gap-4") }, sanitizedCategoryRatings.map(function (_a) {
                var category = _a.category, rating = _a.rating, icon = _a.icon;
                return (React.createElement(HeaderItem, { key: category, title: category == "Hostess" ? isYachtsAndFriends ? "Chef" : "Host" : category, subTitle: rating, icon: icon }));
            }))),
        React.createElement("div", { className: 'dui-mt-8 dui-flex dui-flex-col sm:dui-flex-row dui-items-center dui-gap-4 md:dui-gap-2' },
            React.createElement("a", { href: "/reviews".concat(countryCode ? "?country=".concat(countryCode) : ''), target: '_blank', rel: 'noopener noreferrer' },
                React.createElement(Button, { buttonType: 'SECONDARY' },
                    "See all ",
                    total_count,
                    " reviews")),
            React.createElement(Button, { buttonType: 'LINK_UNDERLINE', buttonSize: 'EXTRA_SMALL', onClick: function () { return openInfoDrawer({
                    content: React.createElement(ReviewsInfo, null)
                }); } }, "Learn how reviews work"))));
};
export default Large;
